import { ContextActionType } from '../actions/context-action.js';
import { PreviewActionType } from '../actions/preview-actions.js';
import { usePreviewWebSocket } from './use-preview-websocket.js';
/**
 * Custom hook for creating application preview actions, used within the context menu of wrapped elements.
 *
 * @param props - Properties for the hook.
 */
function useApplicationPreviewActions(props) {
    const { fragment, node } = props;
    const { sendMessage } = usePreviewWebSocket();
    /**
     * Sends a message to open the given fragment.
     */
    const sendOpenFragmentMessage = () => {
        sendMessage({
            fragment,
            type: PreviewActionType.OPEN_FRAGMENT,
        });
    };
    /**
     * Sends a message to edit the properties of the given fragment node.
     */
    const sendEditFragmentNodeMessage = () => {
        sendMessage({
            fragment,
            node,
            type: PreviewActionType.EDIT_NODE,
        });
    };
    /**
     * Sends a message to show the given fragment node on the Editor tree.
     */
    const sendShowFragmentNodeMessage = () => {
        sendMessage({
            fragment,
            node,
            type: PreviewActionType.SHOW_NODE,
        });
    };
    const openFragmentAction = {
        callee: sendOpenFragmentMessage,
        id: 'oswald.preview.open-fragment',
        title: 'Open Fragment',
        type: ContextActionType.ACTION,
    };
    const showFragmentNodeAction = {
        callee: sendShowFragmentNodeMessage,
        id: 'oswald.preview.show-fragment-node',
        title: 'Show node on tree',
        type: ContextActionType.ACTION,
    };
    const editFragmentNodeAction = {
        callee: sendEditFragmentNodeMessage,
        id: 'oswald.preview.edit-fragment-node',
        title: 'Edit Properties',
        type: ContextActionType.ACTION,
    };
    return [
        openFragmentAction,
        showFragmentNodeAction,
        editFragmentNodeAction,
    ];
}
export { useApplicationPreviewActions, };
//# sourceMappingURL=use-application-preview-actions.js.map